import { render, staticRenderFns } from "./ImportExportModule.vue?vue&type=template&id=3129b7c4&"
import script from "./ImportExportModule.vue?vue&type=script&lang=js&"
export * from "./ImportExportModule.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports